import AboutNavigation from "@/components/atom/AboutNavigation/AboutNavigation";
import FeedbackInfoSidebar from "@/components/organism/FeedbackInfoSidebar/FeedbackInfoSidebar";
import OnboardingIntroductionContent
  from "@/components/organism/OnboardingIntroductionContent/OnboardingIntroductionContent";
import ThreadsHistory from "@/components/organism/ThreadHistory/ThreadsHistory";
import ChatWindow from "@/components/pages/ChatWindow/ChatWindow";
import FeedbackPage from "@/components/pages/FeedbackPage/FeedbackPage";
import GetStartedPage from "@/components/pages/GetStarted/GetStartedPage";

export const componentMap = {
  chat: {
    sidebarComponent: ThreadsHistory,
    mainComponent: ChatWindow
  },
  about: {
    sidebarComponent: AboutNavigation,
    mainComponent: GetStartedPage,
  },
  feedback: {
    sidebarComponent: FeedbackInfoSidebar,
    mainComponent: FeedbackPage,
  },
  onboardingMode: {
    sidebarComponent: OnboardingIntroductionContent,
    mainComponent: ChatWindow,
  },
} as const;
